import React, { useEffect, useState } from "react";

import { useSelector, useDispatch } from "react-redux";
import { useForm } from "react-hook-form";
import { RideGrid } from "@rimac-seguros/ride-system-components";

import FormContact from "../FormContact/index";
import FormUbigeo from "../FormUbigeo/index";
import FormJob from "../FormJob/index";
import useResponsiveDetection from "@/hooks/useResponsiveDetection";
import { CardDetailPlan } from "../../../shared/components/CardDetailPlan";
import { SectionAction } from "../SectionAction/index";
import { cleanToken } from "@/redux/actions/token";
import { resetThirdState } from "@/redux/actions/plans";
import { ModalRightOfWithdrawal } from "../ModalRightOfWithdrawal/index";
import { StateMachine } from "@/utils/consts";
import { setViewModalError, setPaymentSuscribed } from "@/redux/actions/global";
import helpers from "@/utils/helpers";
import { SectionBeneficiaries } from "@/components/organisms/SectionBeneficiaries/index";


import "./styles.scss";

const SectionPersonalData = (props) => {
  const {
    register,
    watch,
    setValue,
    trigger,
    setError,
    formState: { errors },
  } = useForm({
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      streetType: "AV",
    },
  });

  const { isSmallScreen } = useResponsiveDetection();
  const dispatch = useDispatch();
  const [showModalExclusions, setShowModalExclusions] = useState(false);
  const { userData } = useSelector((state) => state.vida);
  const { selectedJob, isWorking, company } = useSelector(
    (state) => state.jobs
  );
  const { state } = useSelector((state) => state.global);
  const { beneficiaryType } = useSelector((state) => state.beneficiaries);

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      document.body.style.height = `${window.innerHeight}px`;
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const setInitialValues = () => {
    setValue("email", userData.email || userData.correo || "");
    setValue("phone", userData.telefono || "");
    setValue("job", selectedJob || "");
    setValue("isWorking", isWorking || "");
    setValue("company", company || "");
    setValue("beneficiaryType", beneficiaryType || "");
  };

  useEffect(() => {
    dispatch(cleanToken());
    dispatch(resetThirdState());
    setInitialValues();
    dispatch(setPaymentSuscribed(false));
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  useEffect(() => {
    if (userData.indPrevPageApp) {
      helpers.sendMessageToApp(showModalExclusions ? "EMBEDDED-APP-HIDE-TOPBAR" : "EMBEDDED-APP-SHOW-TOPBAR");
    }
  }, [showModalExclusions, userData.indPrevPageApp]);

  useEffect(() => {
    if (state === StateMachine[4]) {
      return dispatch(setViewModalError(true));
    }
  }, [state]);

  const callAnalyticsAction = () => {
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Dirección",
      "click",
      "Ver más",
      "trackAction"
    );
  };

  const handleOpenModalExclusions = () => {
    helpers.getTagAction(
      "Seguro Vida Devolución Garantizada",
      "Dirección",
      "click",
      "Exclusiones",
      "trackAction"
    );
    setShowModalExclusions(true);
  };

  return (
    <>
      <div className="section-personal-data">
        <RideGrid>
          <h2 className="section-personal-data_title">
            Completa <span>tus datos</span>
          </h2>
          <div className="col-span-full lg:col-span-7 xl:col-span-6">
            <FormContact
              register={register}
              errors={errors}
              setValue={setValue}
            />
            <FormUbigeo
              register={register}
              errors={errors}
              setError={setError}
              setValue={setValue}
              watch={watch}
              isSmallScreen={isSmallScreen}
              loading={loading}
              setLoading={setLoading}
            />
            <FormJob
              register={register}
              errors={errors}
              setError={setError}
              setValue={setValue}
              watch={watch}
              isSmallScreen={isSmallScreen}
            />
            <SectionBeneficiaries
              register={register}
              watch={watch}
              errors={errors}
            />
            <p className="section-personal-data_exclusions">
              Al continuar, aceptas haber leído las{" "}
              <span onClick={handleOpenModalExclusions}>exclusiones.</span>
            </p>
          </div>
          <div className="hidden lg:block lg:col-span-5 lg:col-start-8">
            <CardDetailPlan callAnalyticsAction={callAnalyticsAction} />
          </div>
        </RideGrid>
      </div>
      <SectionAction
        trigger={trigger}
        errors={errors}
        data={watch()}
        loading={loading}
        {...props}
      />
      {showModalExclusions && (
        <ModalRightOfWithdrawal
          isOpen={showModalExclusions}
          onClose={() => setShowModalExclusions(false)}
        />
      )}
    </>
  );
};

export default SectionPersonalData;
